export const DailyReportData = [
  {
    id: 1,
    Deal_Name: "Collins",
    Stage: "Qualify To Buy",
    Deal_Value: "$04,51,000",
    tag1: "Collab",
    close_date: "25 Sep 2023",
    created_date: "25 Sep 2023, 01:22 pm",
    owner: "Hendry",
    source: "Paid Social",
    Probability: "90%",
    Status: "Won",
    key: "1"
  },
  {
    id: 2,
    Deal_Name: "Konopelski",
    Stage: "Proposal Made",
    Deal_Value: "$03,12,500",
    tag1: "Rated",
    close_date: "29 Sep 2023",
    created_date: "29 Sep 2023, 04:15 pm",
    owner: "Guillory",
    source: "Referrals",
    Probability: "15 %",
    Status: "Lost",
    key: "2"
  },
  {
    id: 3,
    Deal_Name: "Adams",
    Stage: "Contact Made",
    Deal_Value: "$04,14,800",
    tag1: "Rejected",
    close_date: "04 Oct 2023",
    created_date: "04 Oct 2023, 10:18 am",
    owner: "Jami",
    source: "Campaigns",
    Probability: "95 %",
    Status: "Won",
    key: "3"
  },
  {
    id: 4,
    Deal_Name: "Schumm",
    Stage: "Qualify To Buy",
    Deal_Value: "$11,14,400",
    tag1: "Collab",
    close_date: "15 Oct 2023",
    created_date: "17 Oct 2023, 03:31 pm",
    owner: "Theresa",
    source: "Google",
    Probability: "99 %",
    Status: "Won",
    key: "4"
  },
  {
    id: 5,
    Deal_Name: "Wisozk",
    Stage: "Presentation",
    Deal_Value: "$16,11,400",
    tag1: "Rated",
    close_date: "27 Oct 2023",
    created_date: "24 Oct 2023, 09:14 pm",
    owner: "Espinosa",
    source: "Paid Social",
    Probability: "10 %",
    Status: "Open",
    key: "5"
  },
  {
    id: 6,
    Deal_Name: "Heller",
    Stage: "Appointment",
    Deal_Value: "$78,11,800",
    tag1: "Rated",
    close_date: "07 Nov 2023",
    created_date: "08 Nov 2023, 09:56 am",
    owner: "Martin",
    source: "Referrals",
    Probability: "70 %",
    Status: "Won",
    key: "6"
  },
  {
    id: 7,
    Deal_Name: "Gutkowski",
    Stage: "Proposal Made",
    Deal_Value: "$09,05,947",
    tag1: "Promotion",
    close_date: "12 Nov 2023",
    created_date: "14 Nov 2023, 04:19 pm",
    owner: "Newell",
    source: "Campaigns",
    Probability: "10 %",
    Status: "Open",
    key: "7"
  },
  {
    id: 8,
    Deal_Name: "Walter",
    Stage: "Qualify To Buy",
    Deal_Value: "$04,51,000",
    tag1: "Rejected",
    close_date: "23 Nov 2023",
    created_date: "23 Nov 2023, 11:14 pm",
    owner: "Janet",
    source: "Google",
    Probability: "90 %",
    Status: "Won",
    key: "8"
  },
  {
    id: 9,
    Deal_Name: "Hansen",
    Stage: "Appointment",
    Deal_Value: "$72,14,078",
    tag1: "Collab",
    close_date: "11 Dec 2023",
    created_date: "10 Dec 2023, 06:43 am",
    owner: "Craig",
    source: "Paid Social",
    Probability: "40 %",
    Status: "Won",
    key: "9"
  },
  {
    id: 10,
    Deal_Name: "Leuschke",
    Stage: "Proposal Made",
    Deal_Value: "$09,05,947",
    tag1: "Rated",
    close_date: "17 Dec 2023",
    created_date: "25 Dec 2023, 08:17 pm",
    owner: "Daniel",
    source: "Referrals",
    Probability: "47 %",
    Status: "Lost",
    key: "10"
  },
];
